import * as React from "react";
import * as ReactDOM from "react-dom";
import GA from "../../common/services/GA";
import { GA_KEY } from "appConfig";
import App from "./components/App";

(async () => {
  GA.initialize(GA_KEY);

  ReactDOM.render(<App />, document.getElementById("root"));
})();
